'use strict';

/**
 * Change FAQ url
 * @param {string} value id of the faq category
 */
function setParamToURL(value) {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set('c', value);
    history.replaceState(null, null, '?' + queryParams.toString());
}

$(document).ready(function () {
    var $faqSelect = $('#faq-selection');
    // Set URL Param on page load
    var onloadValue = $faqSelect.val();
    setParamToURL(onloadValue);

    $faqSelect.on('change', function () {
        var value = $(this).val();
        $('.faq-accordion').addClass('d-none');
        $('#' + value).removeClass('d-none');
        // Set URL Param on category change
        setParamToURL(value);
    });
});
